module.exports = __webpack_public_path__ + "img/RTC11E.98e42aab.svg";